import { styled } from '@mui/material/styles';

export const MainBlock = styled('main')`
  width: 100%;
  min-height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;
